export default function validHour(Authentication, Utils) {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$validators.validHour = function validHourValidator(modelValue, viewValue) {
        if (
          'validHourOptional' in $attrs &&
          $attrs.validHourOptional !== 'false' &&
          $ctrl.$isEmpty(modelValue)
        ) {
          return true;
        }

        return Utils.parseTimeString(viewValue) !== null;
      };
    },
  };
}
